import React from 'react';
import Image from 'react-bootstrap/Image';
import locationIcon from '../../../images/location.png';

function LocationImage() {
    
    return  <Image src={locationIcon} fluid alt="lokasjons-ikon"/>;
    
}
export default LocationImage;